import { defineComponent as _defineComponent } from 'vue'
import CcCheckbox from '@/views/Automation/CampaignCreatorV2/components/CcCheckbox/CcCheckbox.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { ViewLevelActionsEvent } from '@/views/Automation/CampaignCreatorV2/components/CcPopover/helpers';
import { ViewLevelAction } from '@/views/Automation/CampaignCreatorV2/types';
import { PopoverTriggers, Position, TooltipPlacement } from '@sh/types';
import { ref } from 'vue';

interface Props {
  target: string;
  placement?: TooltipPlacement;
  header?: string;
  actions?: ViewLevelAction[][];
  groups?: string[];
  showCheck?: boolean;
  triggers?: PopoverTriggers[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcActionsPopover.ts',
  props: {
    target: null,
    placement: { default: Position.RIGHT },
    header: { default: '' },
    actions: null,
    groups: null,
    showCheck: { type: Boolean },
    triggers: { default: () => [PopoverTriggers.CLICK, PopoverTriggers.BLUR] }
  },
  emits: ["event", "fullEvent"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'event', value: ViewLevelActionsEvent): void;
  (e: 'fullEvent', value: ViewLevelAction<string, any>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { target: string, placement: TooltipPlacement, header: string, actions?: ViewLevelAction[][], groups?: string[], showCheck?: boolean, triggers: PopoverTriggers[] };





const show = ref(false);

function publishEvent(action: ViewLevelAction<string, any>) {
  emits('fullEvent', action);
}

function onActionClick(action: ViewLevelAction) {
  publishEvent(action);
  emits('event', action.event as ViewLevelActionsEvent);

  if (!props.showCheck) {
    show.value = false;
  }
}

return { __sfc: true,props, emits, show, publishEvent, onActionClick, CcCheckbox, CcIcon }
}

})